import { useEffect, useState } from "react";

/** Keep a lazily-mounted sheet in the tree long enough to play its slide-down close animation. */
export default function useDelayedUnmount(open, ms = 400) {
  const [mounted, setMounted] = useState(open);
  useEffect(() => {
    if (open) { setMounted(true); return undefined; }
    const t = setTimeout(() => setMounted(false), ms);
    return () => clearTimeout(t);
  }, [open, ms]);
  return mounted || open;
}
